export default class GeometryFilter {
  filter(geom) {}
}
export default class GeometryFilter {
  filter(geom) {}
}
